import fastdom from 'fastdom';
import { onloadingArticleSearchResults$, onArticleSearchResultsLoaded$ } from 'features/articleSearchResultsFacets';

/**
 * Scrolls the page to the top with a smooth animation.
 */
const scrollToTopPage = function() {
  fastdom.mutate(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) });
};

/**
 * Renders the article search results into the DOM.
 * @param {string} htmlResponse - The HTML string containing the article search results.
 */
const renderArticleResults = function(htmlResponse) {
  const articlesContainer = document.querySelector('[data-component="article-search-results"]');
  if (!articlesContainer) { return; }
  fastdom.mutate(() => {
    articlesContainer.innerHTML = htmlResponse;
    fastdom.measure(() => {
      if (htmlResponse) {
        articlesContainer.removeAttribute('hidden');
      } else {
        articlesContainer.setAttribute('hidden', '');
      }
    });
  });
};

// Subscribe to the observables to trigger the scroll and render functions
onloadingArticleSearchResults$.subscribe(scrollToTopPage);
onArticleSearchResultsLoaded$.subscribe(renderArticleResults);